import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  items: null,
  value: 0,
}

// sliceを生成
export const itemListSlice = createSlice({
  // SliceごとにStore、Reducer、Actionを管理できる
  name: 'count', //  Sliceの名称 ※ stateの名前ではない(変更する場合でもここだけ変えれば良い)
  initialState,
  // Stateに対して許可する更新処理を定義する場所
  reducers: {
    hydrate: (state, action) => {
      return {
        ...state,
        value: action.payload,
        items: action.payload
      }
    },
    // ここに定義したキーがAction Creator関数の名前となる
    // つまり、Action Creatorは自動生成される
    increment: (state) => {
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    // 第一引数は現在（更新前）のState 第二引数は渡されたaction
    // action.payloadプロパティに、Action Creatorに渡された引数が入っている
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },
    setListItems: (state, action) => {
      return {
        ...state,
        items: action.payload
      }
    }
  },
})

// Action Creatorsをエクスポートする (jsxでこのアクションをdispatchさせる。→ 上記のslice内で対応したアクションの関数が実行)
export const { increment, decrement, incrementByAmount, setListItems, hydrate } = itemListSlice.actions

export default itemListSlice.reducer


// 非同期処理は関数としてエクスポートする
// export function someAsyncTask() {
//   // dispatch 関数を引数に取る関数を返却する
//   return async function(dispatch) {
//     try {
//       const response = await api.doSomething();
//       // 非同期処理の中で定義した Action Creator を呼び出すことができる
//       dispatch(setListItems(response.data));
//     } catch(err) {
//       // エラー処理
//     }
//   }
// }
// → jsx側で someAsyncTask をdispatchすることも可能。 デフォルトのRedux Thunkを使用



// const slice = createSlice(/* ... */);
// によって、以下が生成される。

// slice.name; // Sliceの名称
// slice.actions; // Action Creator関数
// slice.reducer; // Reducer関数 -> sliceReducerという名前のreducerでindex.jsを経由してstore.jsでimportする。
